import { IonLoading, IonToast } from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { setInitialData } from "../../../store/formsubmitted";
import { RootState } from "../../../store/rootReducer";
import { findTemplatesAssignedToUser } from "../../../store/templateList/actions/findTemplatesAssignedToUser";

export const AssignUserStatus = () => {
    const { id }: { id: string } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const assignUserToFormStatus = useSelector((state: RootState) => state.formSubmittedSlice.assignUserToFormStatus);

    const handleFinishedAssign = async () => {
        await dispatch(findTemplatesAssignedToUser({ user: id }));
        dispatch(setInitialData());
        history.replace(`/app/rrhh/usuarios/acuerdos/${id}`);
    }

    return (
        <>
            <IonLoading isOpen={assignUserToFormStatus === "pending"} message={"Asociando plantilla..."} />
            {assignUserToFormStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="La plantilla fue asociada satisfactoriamente"
                    position="bottom"
                    duration={3000}
                    color="success"
                />
            )}

            {assignUserToFormStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al asignar la plantilla"
                    position="bottom"
                    duration={3000}
                    color="danger"
                />
            )}
        </>
    );
};
